 <template>
	 <div class="mdc-dialog darkModeModal" data-mdc-auto-init="MDCDialog" style="display: block;">
						<div class="mdc-dialog__container"
							style="opacity:1; transform: scale(1);padding-bottom: 150px;">
							<div class="mdc-dialog__surface" role="alertdialog" aria-modal="true"
								aria-labelledby="my-dialog-title" aria-describedby="my-dialog-content"
								style="max-height:546px;">
								<div class="pdl-24 pdr-24 pdt-3 pdb-3 d-flex">
									<i class="material-icons t-color-whiteHigh visibility-h">close</i>
									<div class="t-color-whiteHigh t-subtitle4 t-center font-r t-center flex-grow-1 d-flex align-items-center justify-content-center"> {{$t('1090')}}
									</div>
									<i class="material-icons t-color-whiteHigh mdc-icon-button" @click="onClose()"  @keypress="onClose()" tabindex="0">close</i>
								</div>
								<div class="divider-white"></div>

								<div class="mdc-dialog__content pda-24" id="my-dialog-content" v-if="currentTimelineContents.quiz" >
									<div class="t-subtitle6  t-line-h-28 t-color-whiteHigh l-spacing2">
										 {{currentTimelineContents.quiz.question}}
									</div>
									<div class="mgt-16 cursor-pointer">
										<div class=" b-radius4 pdt-14 pdb-14 pdl-24 pdr-24 mgb-8 setClass" 
											v-for="(view, index) in currentTimelineContents.quiz.views" 
											:key="index"  tabindex="0"
											:class="submitStatus && index===userAnswer && correctStauts ? 'bg-contentBlue correctAns': submitStatus && index===userAnswer && !correctStauts ? 'bg-contentRed' : index===userAnswer ? 'bg-quizBlack currentSelected' : 'bg-quizGray'"
											@click="!submitStatus ? setUserAnawer(index) : null" @keypress="!submitStatus ? setUserAnawer(index) : null"
										
										>
											<div class="d-flex align-items-center">
												<div class="q-count t-body1 l-spacing48 font-rn " 
												:class="(lightModeActive && submitStatus && index===userAnswer && correctStauts) ? 't-color-white lightmode' : 't-color-whiteHigh darkmode' " v-if="index===userAnswer && correctStauts === true  && submitStatus === true"></div>
												<div class="q-count incorrect darkmode t-body1 l-spacing48 font-rn" :class="(lightModeActive && submitStatus && index===userAnswer && !correctStauts)  ? 't-color-white' : 't-color-whiteHigh' " v-else-if="index===userAnswer && correctStauts === false && submitStatus === true">
													<i class="material-icons">close</i>
												</div>
												<div
													v-else
													class="q-count  t-body1 l-spacing48 font-rn" :class="(lightModeActive && index===userAnswer) ? 't-color-white lightmode' : 't-color-whiteHigh darkmode' ">
													{{index+1}}
												</div>
												<div class="t-body1 font-r flex-grow-1 font-r" :class="(lightModeActive && (submitStatus && index===userAnswer && correctStauts)  || ( index===userAnswer) || (submitStatus && index===userAnswer && !correctStauts)) ? 't-color-white' : 't-color-whiteHigh' "> {{view.text}}
												</div>
												<!-- <div class="t-headline9 t-color-whiteMedium">78%</div> -->
											</div>
										</div>
										<!-- <div class="h-49"></div> -->
									</div>
								</div>

								<div class="mdc-dialog__actions pdl-24 pdr-24 pdb-25 pdt-9">

									<button class="mdc-button mdc-button--raised  b-radius4 w-full" :class="!checkAnswer?'bg-disableBtn t-color-disableBtnText':'bg-mainBtn t-color-mainBtnText'" tabindex="0" @click="answerSubmit()" @keypress="answerSubmit()" :disabled="!checkAnswer" v-if="!submitStatus" >
										<span class="mdc-button__label t-body2 font-r">{{$t('1091')}}</span>
									</button>

									<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 w-full" tabindex="0"  @click="confirm()" @keypress="confirm()" v-if="submitStatus" >
										<span class="mdc-button__label t-body2 font-r" >{{$t('994')}}</span>
									</button>

									<!-- <button class="mdc-button  bg-disableBtn  w-full disabled"  @click="confirm()" v-if="submitStatus" >
										<span class="mdc-button__label t-body2 font-r t-color-disableBtnText">{{$t('994')}}</span>
									</button> -->

								</div>

							</div>
						</div>
						<div class="mdc-dialog__scrim" style="opacity:1;"></div>
					</div>
</template>
<script>
/**
 * 나의 학습 차시 학습창 - 타임라인 퀴즈 컨텐츠 상세 컴포넌트(my learning lesson study - timeline quiz contents detail component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
export default {
	props: ['currentTimelineContents', 'lightModeActive'],
	data() {
		return {
			userAnswer: -1,
			submitStatus: false,
			correctStauts: false
		}
	},
		
	computed: {
		// 답안 체크 여부 확인(Check answer check)
		checkAnswer() {
			return  this.userAnswer >= 0 ? true : false
		}
	},
	mounted() {
		this.setMaterialUi()
	},
	methods: {
		// 퀴즈 상세 닫기(close Quiz Detail)
		onClose() {
			this.$emit('closeQuizDetail');
		},

		// 답안 설정(set answer)
		setUserAnawer(answer) {
			this.userAnswer = answer
		},

		// 정답 제출(submit answer)
		answerSubmit() {
			// console.log(this.userAnswer);
			this.submitStatus = true            
			let alertParams = null
			if (this.currentTimelineContents.quiz.views[this.userAnswer].correct) {
				this.correctStauts = true
			}else {
				this.correctStauts = false
			}
		},

		confirm() {
			this.onClose()
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	}
}
</script>
<style scoped>
@media (orientation: landscape){
#quizDetailContainer{
	width: 100%  !important;
	left: 0;
	position: absolute !important;
	z-index: 999;
	margin: 0 auto;
}
html[dir="rtl"] #quizDetailContainer{
	right: 0;
}
section#quizDetailContents {
	padding: 0 100px !important;
}
#quizDetailContainer header{
	background-color: transparent!important;
}
.q-count.lightmode{
	border: 1px solid var(--DocumentWhite);
}
.correctAns .q-count.lightmode{
	border: 3px solid var(--DocumentWhite);
}
#quizDetailContainer header .mdc-top-app-bar__title{
	color:var(--WhiteHigh)!important;

}
#studyContainer #quizDetailContainer header .mdc-top-app-bar__navigation-icon{
	background-color: transparent!important;
}
#studyContainer #quizDetailContainer #quizDetailContents .question-choices .choice{
	background-color: transparent!important;
}
#studyContainer #quizDetailContainer #quizDetailContents .question-choices .choice.on{
	background-color:var(--QuizBlack)!important;
}
#studyContainer #quizDetailContainer #quizDetailContents .question-choices .choice.incorrect{
	background-color:var(--ContentRed)!important;
}
#studyContainer #quizDetailContainer #quizDetailContents .question-choices .choice.correct{
	background-color:var(--ContentBlue)!important;
}
#studyContainer #quizDetailContainer header .mdc-top-app-bar__navigation-icon{
	color:var(--WhiteHigh)!important;
	margin-left:38px;
}
html[dir="rtl"] #studyContainer #quizDetailContainer header .mdc-top-app-bar__navigation-icon{
	margin-right:38px;
}
#studyContainer #quizDetailContainer{
	background-color: var(--ContentsDim)  !important;
}
#studyContainer #quizDetailContainer > div .submit {
	
	position: absolute;
	border: 0;
	bottom: 0;
	width: 100%;
	left: 0;
	bottom: 0;
	height: 84px;
	background:var(--ContentsDim);
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 0 !important;
}
html[dir="rtl"] #studyContainer #quizDetailContainer > div .submit {
	right: 0;
}
#studyContainer #quizDetailContainer > div .submit button{
	width: calc(100% - 200px) !important;
}
#studyContainer #quizDetailContainer #quizDetailContents .question-choices .choice{
	color:var(--WhiteHigh)  !important;
}
#studyContainer #quizDetailContainer #quizDetailContents .question-choices .choice .number-circle {
	color:var(--WhiteHigh)  !important;
}
#studyContainer #quizDetailContainer #quizDetailContents .question-choices .number-circle{
	border-color:var(--WhiteHigh)  !important;
}
}
.currentSelected .q-count{
	border-width: 1px;
	/* margin-left: -2px; */
}
html[dir="rtl"] .currentSelected .q-count{
	border-width: 1px;
	margin-right: -2px;
}

</style>